/**
 * C7 departments view-model — pure display shaping kept out of the .vue so
 * node:test can cover the logic directly (the companies repo has no SFC test
 * runner). The template just binds the output.
 *
 * A Department (§3) carries { id, nameAr, managerName, isActive }; the
 * "عدد الموظفين" column is computed from the employees list (each employee has a
 * deptId), never stored on the department itself.
 */

// Count employees per department id -> { deptId: count }.
function countByDept(employees) {
  var map = {};
  var rows = employees || [];
  for (var i = 0; i < rows.length; i++) {
    var key = String(rows[i].deptId);
    if (key === 'undefined' || key === 'null') continue;
    map[key] = (map[key] || 0) + 1;
  }
  return map;
}

// Two-letter avatar initials — first two letters of the leading name token,
// mirroring the mockup ("أحمد سمير" -> "أح", "منى" -> "من").
function initials(name) {
  var s = String(name || '').trim();
  if (!s) return '؟';
  var first = s.split(/\s+/)[0];
  return first.length > 1 ? first.slice(0, 2) : first;
}

var AVATAR_TINTS = ['', 'a2', 'a3'];

// Shape raw departments into display rows (with employee counts + status ui).
function shapeRows(departments, counts) {
  var rows = departments || [];
  return rows.map(function (d, i) {
    var active = d.isActive !== false;
    return {
      id: d.id,
      nameAr: d.nameAr || '',
      managerName: d.managerName || '',
      isActive: active,
      employeeCount: (counts && counts[String(d.id)]) || 0,
      initials: initials(d.managerName),
      avatarClass: AVATAR_TINTS[i % AVATAR_TINTS.length],
      statusKey: active ? 'active' : 'suspended',
      statusTag: active ? 'ok' : 'review',
    };
  });
}

// Client-side chip filter: 'all' | 'active' | 'suspended'.
function filterRows(rows, filter) {
  var r = rows || [];
  if (filter === 'active') return r.filter(function (x) { return x.isActive; });
  if (filter === 'suspended') return r.filter(function (x) { return !x.isActive; });
  return r;
}

// Footer roll-up over the full (unfiltered) list.
function summary(rows) {
  var r = rows || [];
  var active = 0;
  var employees = 0;
  for (var i = 0; i < r.length; i++) {
    if (r[i].isActive) active += 1;
    employees += Number(r[i].employeeCount) || 0;
  }
  return {
    total: r.length,
    active: active,
    suspended: r.length - active,
    totalEmployees: employees,
  };
}

// ── C3 «زرار حذف soft delete» ──────────────────────────────────────────────
//
// DELETE /departments/:id is a soft delete (the row is stamped deletedAt and
// leaves every list). It is REFUSED with 409 DEPARTMENT_HAS_EMPLOYEES while
// live employees are still assigned, rather than leaving their Employee.deptId
// pointing at something no screen can render — so the 409 is a normal outcome
// the UI must explain, not an error to swallow.

var DELETE_API_ERRORS = {
  DEPARTMENT_HAS_EMPLOYEES: 'hasEmployees',
  DEPARTMENT_NOT_FOUND: 'notFound',
  COMPANY_CONTEXT_MISSING: 'forbidden',
};

function deleteErrorKey(err) {
  var e = err || {};
  var res = e.response;
  if (!res) return 'network';
  var code = res.data && res.data.code;
  if (code && DELETE_API_ERRORS[code]) return DELETE_API_ERRORS[code];
  if (res.status === 409) return 'hasEmployees';
  if (res.status === 403) return 'forbidden';
  if (res.status === 404) return 'notFound';
  return 'generic';
}

module.exports = {
  countByDept: countByDept,
  initials: initials,
  shapeRows: shapeRows,
  filterRows: filterRows,
  summary: summary,
  AVATAR_TINTS: AVATAR_TINTS,
  DELETE_API_ERRORS: DELETE_API_ERRORS,
  deleteErrorKey: deleteErrorKey,
};
